import { useEffect, useState } from "react";
import { apiJson } from "../dependencies/api.ts";
import { useMessageHandler } from "../context/MessageContext.tsx";

export const useBinaryVersion = () => {
  const [version, setVersion ] = useState<string>("");
  const { handle } = useMessageHandler();

  useEffect(() => {
    const fetchVersion = async () => {
      await handle(async () => {
        setTimeout(async () => {
          try {
            const response = await apiJson.get("/binary/version");
            const text = response.data;
            setVersion(text);
          } catch (e) {
            console.error("Fehler beim Laden der Version:", e);
          }
        }, 0);
      });
    };

    fetchVersion();
  }, []);


  return { version };
};